<template>
  <div id="addEdit">
    <el-dialog :title="formData.credit_id?'编辑征信':'添加征信'" :visible.sync="visible" width="600px">

      <el-form :model="formData" :rules="rules" ref="form"  label-width="80px" class="demo-ruleForm" size="small">
        <el-form-item prop="name" label="征信名称">
          <el-input v-model="formData.name" placeholder="请输入征信名称"></el-input>
        </el-form-item>
        <el-form-item prop="sort" label="征信排序">
          <el-input v-model.number="formData.sort" placeholder="请输入征信排序"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="visible = false">取消</el-button>
        <el-button type="primary" @click="submitSave" :loading="loading">确定</el-button>
      </div>

    </el-dialog>


  </div>
  </template>

  <script>
  import NeedApi from '@/api/need'
  export default {
    data(){
      return{
        loading:false,
        visible:false,
        formData:{
          name:'',
          sort:1,
        },
        rules: {
          name: [{ required: true, message: '请输入业务名称', trigger: 'blur' }],
          sort: [{ required: true, message: '请输入业务排序', trigger: 'blur' }],
        },
      }
    },
    methods:{

      /*提交保存*/
      submitSave(){
        let params = JSON.parse(JSON.stringify(this.formData));
        this.$refs.form.validate((valid) => {
          if (valid) {
            this.loading = true;
            let API=this.formData.credit_id?'setCreditEdit':'creditAdd'
            NeedApi[API](params).then(data => {
              this.$message({
                message: '保存成功',
                type: 'success'
              });
              this.visible=false
              this.$emit('refresh')
            }).finally(() => {
              this.loading = false;
            });
          }
        });
      },

      /*显示弹窗*/
      show(e){
        this.visible=true
        this.formData.credit_id=null
        this.$nextTick(()=>{
          this.$refs.form.resetFields()
          if(e&&e!=''){
            this.formData.credit_id=e.credit_id
            for(let i in this.formData){
              if(e[i]){
                this.formData[i]=e[i]
              }
            }
          }
        })
      },


    },

  }
  </script>

  <style lang="scss" scoped>
  .img{margin-top: 10px;}
  </style>


// WEBPACK FOOTER //
// src/views/need/credit/addEdit.vue